import {
    cleanCommonParams,
    mapAttachmentsParams,
    mapTagsParams,
    mapContentParams,
    mapFeedItemParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
} from './common';

const mapAlertParams = (
    isCreate,
    {
        attachments,
        tags,
        categories,
        content,
        feed_item,
        platforms,
        products,
        sales_channels,
        search_phrase_ids,
        states,
        read_by_user,
        expired_at,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            alert: {
                ...cleanCommonParams(params),
                ...mapAttachmentsParams(isCreate, attachments),
                ...mapTagsParams(isCreate, tags),
                ...mapContentParams(isCreate, content),
                ...mapFeedItemParams(isCreate, feed_item),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapStatesParams(isCreate, states),
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapAlertParams };
